import { Injectable } from '@angular/core';
import { GdprResources } from './gdpr.resources';
import { ConfirmAndTakeActionService, ModalFactory } from '@yourcause/common/modals';
import { RequestToBeForgottenModalComponent } from './request-to-be-forgotten-modal/request-to-be-forgotten-modal.component';
import { I18nService } from '@yourcause/common/i18n';

@Injectable({ providedIn: 'root' })
export class GdprService {

  constructor (
    private gdprResources: GdprResources,
    private confirmAndTakeAction: ConfirmAndTakeActionService,
    private modalFactory: ModalFactory,
    private i18n: I18nService
  ) { }

  /**
   * Opens the Request to Be Forgotten Modal and Handles the Result
   */
  async requestToBeForgottenModal () {
    const response = await this.modalFactory.open(
      RequestToBeForgottenModalComponent,
      {}
    );
    if (!!response) {
      await this.handleAppsToBeForgotten(response.applicationIds, response.email);
    }
  }

  /**
   * Obfuscates the applications for the given applicant email
   *
   * @param applicationIds: App IDs to obfuscate
   * @param email: Email to obfuscate
   */
  async handleAppsToBeForgotten (
    applicationIds: number[],
    email: string,
    skipToastr = false,
    skipSpinner = false
  ) {
    await this.confirmAndTakeAction.genericTakeAction(
      () => this.gdprResources.obfuscateApplicationsForApplicant(applicationIds, email),
      skipToastr ? '' : this.i18n.translate(
        'common:textSuccessHandleRequest',
        {},
        'Successfully handled the request'
      ),
      this.i18n.translate(
        'common:textErrorHandlingRequest',
        {},
        'There was an error handling the request'
      ),
      skipSpinner
    );
  }

  /**
   * Get a list of applications given an applicant's email
   *
   * @param email: Email to find applications for
   * @returns a list of applications for the given applicant email
   */
  async getApplicationsByEmail (email: string) {
    const {
      passed,
      endpointResponse
    } = await this.confirmAndTakeAction.genericTakeAction(
      () => this.gdprResources.getApplicationsByEmail(email),
      '',
      ''
    );

    return passed ? endpointResponse : null;
  }
}
